import React, { useState } from 'react';
import { Layout } from './Layout';
import { Button, Divider, Header, Message, Segment } from 'semantic-ui-react';
import { userManageClient } from '../userManageClient';
import { buildUrl, AppRoutes } from '../../AppRoutes';
import { BPButton } from '@/components/bp/bpbutton';

export const GenerateRecoveryCodes: React.FC = () => {
    const [recoveryCodes, setRecoveryCodes] = useState<string[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [generateError, setGenerateError] = useState<string>('');

    const handleGenerateCodes = async () => {
        setGenerateError('');
        setLoading(true);
        
        try {
            const result = await userManageClient.generateRecoveryCodes();

            if (result.success && result.recoveryCodes) {
                setRecoveryCodes(result.recoveryCodes);
            } else {
                setGenerateError(result.errors?.join(', ') || 'Failed to generate recovery codes.');
            }
        } catch (error) {
            console.error('Generate recovery codes error:', error);
            setGenerateError('An error occurred while generating recovery codes. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (recoveryCodes) {
        return (
            <Layout>
                <Header as="h1">Recovery codes</Header>
                
                <Message warning>
                    <Message.Header>Your new recovery codes</Message.Header>
                    <p>
                        <strong>Put these codes in a safe place.</strong><br />
                        If you lose your device and don't have the recovery codes you will lose access to your account.
                    </p>
                </Message>

                <Segment>
                    <div style={{ backgroundColor: '#f8f9fa', padding: '1rem', fontFamily: 'monospace' }}>
                        {recoveryCodes.map((code, index) => (
                            <div key={index}>{code}</div>
                        ))}
                    </div>

                    <Divider />
                    
                    <BPButton 
                        as="a"
                        href={buildUrl(AppRoutes.ManageTwoFactor, {})}
                        primary
                    >
                        Continue
                    </BPButton>
                </Segment>
            </Layout>
        );
    }

    return (
        <Layout>
            <Header as="h1">Generate two-factor authentication (2FA) recovery codes</Header>
            
            <Message warning>
                <Message.Header>Warning</Message.Header>
                <p>
                    <strong>When you generate new recovery codes, your old recovery codes are no longer valid.</strong>
                </p>
            </Message>

            <Segment>
                <p>
                    Recovery codes are used to access your account in the event you lose access to your device 
                    and cannot receive two-factor authentication codes.
                </p>

                <p>
                    <strong>Put these codes in a safe place.</strong> If you lose your device and don't have the 
                    recovery codes you will lose access to your account.
                </p>

                {generateError && (
                    <Message error>
                        {generateError}
                    </Message>
                )}

                <Divider />
                
                <BPButton 
                    onClick={handleGenerateCodes}
                    primary 
                    size="large"
                    disabled={loading}
                    loading={loading}
                >
                    Generate Recovery Codes
                </BPButton>
            </Segment>
        </Layout>
    );
};